(() => {
  'use strict';

  const getValue = (params, key) => (params.get(key) || '').trim();

  const normaliseDivision = (value) => {
    const text = (value || '').toLowerCase();
    if (text.includes('food')) return 'Food Ingredients';
    if (text.includes('packaging')) return 'Sustainable Packaging & Products';
    if (text.includes('industrial') || text.includes('infrastructure') || text.includes('composite')) return 'Industrial Materials';
    return value || '';
  };

  const addHidden = (form, label, value) => {
    if (!value) return;
    const key = label.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    let input = form.querySelector(`[data-trison-context="${key}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `contact[${label}]`;
      input.dataset.trisonContext = key;
      form.appendChild(input);
    }
    input.value = value;
  };

  const setSelect = (form, selector, value) => {
    const select = form.querySelector(selector);
    if (!select || !value) return;
    const option = Array.from(select.options).find((item) => item.value === value || item.text === value);
    if (option) select.value = option.value;
  };

  const addNotice = (form, product) => {
    if (!product || form.querySelector('.trison-b2b-form-context')) return;
    const grid = form.querySelector('.trison-b2b-form-grid');
    if (!grid) return;
    const notice = document.createElement('p');
    notice.className = 'trison-b2b-form-context';
    notice.textContent = `Product context: ${product}. This information was carried from the product page; add or adjust the requirement below as needed.`;
    grid.before(notice);
  };

  const refineRfq = (form, division) => {
    const label = form.querySelector('label[for="rfq-format"]');
    const input = form.querySelector('#rfq-format');
    const message = form.querySelector('#rfq-message');
    if (!label || !input) return;

    if (division === 'Food Ingredients') {
      label.textContent = 'Product format / grade / specification';
      input.placeholder = 'e.g. flakes, mesh or cut size, colour, grade';
      if (message) message.placeholder = 'Please include target application, quality requirements, estimated volume, destination and documentation needs.';
    } else if (division === 'Sustainable Packaging & Products') {
      label.textContent = 'Product size / material / branding requirement';
      input.placeholder = 'e.g. capacity, dimensions, material, print requirement';
      if (message) message.placeholder = 'Please include intended application, packaging configuration, artwork or branding needs, destination and target timing.';
    } else if (division === 'Industrial Materials') {
      label.textContent = 'Technical / project requirement';
      input.placeholder = 'e.g. clear opening, load requirement, drawing reference';
      if (message) message.placeholder = 'Please include site application, dimensions, load requirement, drawing or BOQ reference, quantity and project timing.';
    }
  };

  const initialise = () => {
    const params = new URLSearchParams(window.location.search);
    const product = getValue(params, 'product');
    const division = normaliseDivision(getValue(params, 'division'));
    const collection = getValue(params, 'collection');
    const productUrl = getValue(params, 'product_url');
    const source = getValue(params, 'source') || 'website-form';

    document.querySelectorAll('[data-trison-lead-form]').forEach((form) => {
      const route = form.dataset.trisonLeadForm || 'Website enquiry';
      addHidden(form, 'Lead route', route);
      addHidden(form, 'Lead source', source);
      addHidden(form, 'Requested product', product);
      addHidden(form, 'Division context', division);
      addHidden(form, 'Collection context', collection);
      addHidden(form, 'Product URL', productUrl);

      const sampleProduct = form.querySelector('#sample-product');
      if (sampleProduct && product && !sampleProduct.value) sampleProduct.value = product;
      setSelect(form, '#rfq-category', division);
      setSelect(form, '#sample-category', division);
      setSelect(form, '#call-topic', division);
      addNotice(form, product);
      refineRfq(form, division);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();